<script setup lang="ts">
const { gravatar } = defineProps<{
  link: string
  gravatar?: string
}>()
</script>

<template>
  <NuxtLink :to="link" class="flex px-4 py-5 first:mt-0 hover:bg-gray-50 dark:hover:bg-gray-900">
    <UAvatar v-if="gravatar" :src="gravatar" size="md" />
    <div v-else class="flex size-10 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
      <UIcon class="size-5 text-gray-500 dark:text-gray-400" name="regular:file" />
    </div>
    <div class="ml-4 w-full">
      <slot />
    </div>
  </NuxtLink>
</template>
